import type {CSSProperties} from 'react';
import {font, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeCalendarLook = 'calendar-later';

/* Released calendar connect preflight (the Sheet that explains the Google consent before the connect opens Google): Maybe later is a bare full-width
   block with 14px of padding, 14px medium type in the secondary ink and the Wedge font, no fill and no border. It sits under the primary
   action, 4px below it, and that margin is the caller's. It reads the exact legacy roles and keeps the declaration order of the source.
   Cancel in the Tester reset confirmation is the same block with 10px of padding, so the two stay separate looks. The caller owns the
   label, the handler and the margin. */
const LATER_PADDING = 14;

const LOOKS: Record<WedgeCalendarLook, CSSProperties> = {
  'calendar-later': {
    display: 'block', width: '100%', background: 'none', border: 0, color: wedgeExactRole('labelSec'),
    fontSize: font.body, fontWeight: weight.medium, padding: LATER_PADDING, cursor: 'pointer', fontFamily: wedgeExactRole('font'),
  },
};

export const isWedgeCalendarLook = (look: string): look is WedgeCalendarLook => Object.prototype.hasOwnProperty.call(LOOKS, look);
export const wedgeCalendarStyle = (look: WedgeCalendarLook): CSSProperties => ({...LOOKS[look]});
